export const environment = {
  production: true,
  history: 'https://historyapi-int.fcg-live.com/', //'https://fcglivedealerplayer.redimstg.com/',
  envName: 'production',
  firebaseConfig: {
    measurementId: 'G-91ERVCSZZX',
  },
};
// ng build --base-href /signin/viewer/mobile/lobby/ --configuration=production

// ng build help --base-href /signin/viewer/mobile/lobby/ --configuration=production --output-path=dist_help

// Run Both the command separately and Deploy both the build in the same deployment folder
